// extracted by mini-css-extract-plugin
export var circle = "_bd-1";
export var exitConfirmationModal = "_bd-5";
export var iframe = "_bd-0";
export var offline = "_bd-3";
export var online = "_bd-2";
export var workstationSelectError = "_bd-4";